import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import VueSvgInlinePlugin from 'vue-svg-inline-plugin';


import i18nHelper from '/@/helpers/i18nHelper';
import ResponsiveImg from '/@/components/ResponsiveImg/ResponsiveImg.vue';
import fitText from '/@/directives/fitText';
import App from '/@/layouts/App/App.vue';
import router from '/@/router';
import store from '/@/store/store';



//////////
// i18n //
//////////
const initialLanguage = i18nHelper.setInitialLanguage();

const i18n = createI18n({
	locale: initialLanguage,
	fallbackLocale: i18nHelper.getFallbackLanguage(),
	messages: i18nHelper.getTranslations(),
	warnHtmlInMessage: 'off',
});



/////////
// Vue //
/////////
const app = createApp(App);

app.config.globalProperties.$filters = {
	truncate: (text: string, length: number, clamp?: string) => {
		clamp = clamp || '...';
		const node = document.createElement('div');
		node.innerHTML = text;
		const content: any = node.textContent;

		return content.length > length ? content.slice(0, length) + clamp : content;
	},
};

app.use(store)
	.use(router)
	.use(i18n)
	.use(VueSvgInlinePlugin)
	.component('ResponsiveImg', ResponsiveImg)
	.directive('fit-text', {
		mounted: (el: HTMLElement) => {
			setTimeout(() => {
				fitText(el);
			}, 100);

			window.addEventListener('resize', () => {
				fitText(el);
			});
		},
		beforeUnmount: (el: HTMLElement) => {
			window.removeEventListener('resize', () => {
				fitText(el);
			});
		},
	});


app.mount('#vue');
